export default {
  editedService: {},
};
